import { ConstructClassWithPrivateMembers } from '../../../../misc/helpers/ClassWithPrivateMembers';
import { OBSERVABLE_CONTEXT_BASE_PRIVATE } from './privates';
let ALLOW_OBSERVABLE_CONTEXT_BASE_CONSTRUCT = false;
export function AllowObservableContextBaseConstruct(allow) {
    ALLOW_OBSERVABLE_CONTEXT_BASE_CONSTRUCT = allow;
}
export function ConstructObservableContextBase(instance, observable) {
    if (ALLOW_OBSERVABLE_CONTEXT_BASE_CONSTRUCT) {
        ConstructClassWithPrivateMembers(instance, OBSERVABLE_CONTEXT_BASE_PRIVATE);
        instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable = observable;
    }
    else {
        throw new TypeError(`Illegal constructor`);
    }
}
//# sourceMappingURL=constructor.js.map